import componentInit from 'components/componentInit'
import $ from 'jQuery'
import oEmbedAll from 'jQuery.oEmbedAll'

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  mod.initComponents(parentElement)
}

let mod = {}

mod.oEmbedParams = {
  embedMethod: 'fill',
  afterEmbed: (container) =>
  {
    mod.addReadyClass(container.code)
  }
}

mod.initComponents = function(parentElement)
{
  let elements = $(parentElement).find('oembed').get()
  for(let element of elements)
  {
    let url = $(element).html()
    let container = $('<div class="oembed"></div>').get(0)
    $(element).replaceWith(container)

    // OEmbed has difficulties embedding YouTube videos with short URLs. Make
    // short URLs longer.
    let match = url.match(/^(.+)youtu\.be\/(.*)$/)
    if(match && match[1] && match[2])
      url = match[1] +'youtube.com/watch?v='+ match[2]

    $(container).oembed(url, mod.oEmbedParams)
  }
}

mod.addReadyClass = function(iFrameElement)
{
  $(iFrameElement).closest('.oembed').addClass('ready')
}

export default mod



// WEBPACK FOOTER //
// ./vendor/kuvio/kustaa/applications/publicFrontend/scripts/components/oEmbed.js